import React, { useEffect } from 'react';
import HubspotEmbedForm from './HubspotEmbed';
import { Form } from '../../styles/Components/Form/Subscription';
import { handleUTMsEvent } from './Utilities/hubspotEmbedGetUTMs';

const Subscription = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener('hs-form-event:on-ready', handleUTMsEvent);

    return () => {
      window.removeEventListener('hs-form-event:on-ready', handleUTMsEvent);
    };
  }, []);
  return (
    <Form>
      <HubspotEmbedForm
        portalId="243522351"
        formId="02a5c1ce-da55-4b39-a968-31001d9b6e15"
        region="na2"
      />
      <p className="disclaimer">
        By subscribing you agree to with our Privacy Policy and to receive
        updates from us.
      </p>
    </Form>
  );
};

export default Subscription;
